import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Store from './store'
import './plugins/element.js'
import axios from 'axios'
import qs from 'qs'

import { storage } from './util/'
import cookie from './util/cookie.js'

// import VueI18n from 'vue-i18n'
import OneitfarmIgd from '@oneitfarm/idg'
// import OneitfarmRoleManagement from 'oneitfarm_acl'
// import UIComponents from '@oneitfarm/ui-nuclear'
import 'oneitfarm_acl/dist/main.css'
import '@oneitfarm/ui-nuclear/dist/main.css'

import './assets/css/main.css'
// import { storage } from './util/index'
Vue.config.productionTip = false

// let aclAxios = axios.create({
//   baseURL: 'http://w5c0890d624f71.dev.oneitfarm.com/'
// })
// aclAxios.interceptors.request.use(function (config) {
//   var data = config.data
//   var token = storage('token')
//   if (data instanceof FormData) {
//     data.append('token', token)
//     config.data = data
//   } else {
//     data = qs.parse(data)
//     data.token = token
//     config.data = qs.stringify(data)
//   }
//   return config
// }, function (error) {
//   return Promise.reject(error)
// })
// aclAxios.interceptors.response.use(function (response) {
//   return response
// }, (error) => {
//   if (Number.parseInt(error.response.status) === 401) {
//     window.location.href = `${window.origin}/#/login`
//   }
//   return Promise.reject(error)
// })

// Vue.use(VueI18n)
Vue.use(OneitfarmIgd)
// Vue.use(OneitfarmRoleManagement, {
//   routePrefix: '/role-management',
//   router,
//   i18n: {
//     messages: {
//       'zh-CN': {},
//       'en-US': {}
//     }
//   }
// })
// Vue.use(UIComponents)
Vue.config.lang = 'zh-CN'

// axios.defaults.baseURL = 'http://w5c0890d624f71.dev.oneitfarm.com/main.php/json'
// axios.defaults.baseURL = 'http://192.168.2.241/listing/listRecord/webroot/main.php/json'
axios.defaults.baseURL = window.BACKURL

axios.interceptors.request.use(function (config) {
  var data = config.data
  data = qs.parse(data)
  data.appkey = 'nonzy7qlaguzwfbx1rvl5kjmtpaucimr'
  if (storage('token')) data.token = storage('token')
  if (storage('channel')) data.channel = storage('channel')
  config.data = qs.stringify(data)
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
  return response
}, (error) => {
  if (Number.parseInt(error.response.status) === 401) {
    cookie.removeItem('autoLogin')
    window.location.hash = '#/login'
  }
  return Promise.reject(error)
})

Vue.prototype.$http = axios
Vue.prototype.$oneitfarm = {}

new Vue({
  router,
  store: Store.instance,
  render: h => h(App),
  created: function () {
    // let vm = this
    // let appkey = vm.appkey
    // axios.defaults.baseURL = 'http://w5c0890d624f71.dev.oneitfarm.com/main.php/json'
    // axios.interceptors.request.use(function (config) {
    //   var data = config.data
    //   console.log(1)
    //   var data1
    //   if (typeof data === 'string') {
    //     let temp = qs.parse(data)
    //     temp.appkey = appkey
    //     temp.channel = vm.computedChannel
    //     temp.token = vm.computedToken
    //     data1 = qs.stringify(temp)
    //     // data1 = data + (data.length > 0 ? '&' : '') + `appkey=${appkey}&token=${vm.computedToken}&channel=${vm.computedChannel}`
    //   } else if (data instanceof FormData) {
    //     data.append('appkey', appkey)
    //     data.append('token', vm.computedToken)
    //     data.append('channel', vm.computedChannel)
    //     data1 = data
    //   } else {
    //     data.appkey = appkey
    //     data.channel = vm.computedChannel
    //     data.token = vm.computedToken
    //     data1 = qs.stringify(data)
    //   }
    //   // if (storage('token')) data.token = storage('token')
    //   config.data = data1
    //   return config
    // }, function (error) {
    //   return Promise.reject(error)
    // })
    this.$oneitfarm.setChannel = (channel) => {
      storage('channel', channel)
    }
    this.$oneitfarm.getChannel = () => {
      return storage('channel')
    }
    this.$oneitfarm.setToken = (token) => {
      storage('token', token)
    }
    this.$oneitfarm.getToken = () => {
      return storage('token')
    }
    this.$oneitfarm.getAppkey = () => {
      return 'nonzy7qlaguzwfbx1rvl5kjmtpaucimr'
    }
    this.$oneitfarm.hasRole = (targetKey) => {
      let resourceKeys = storage('resourceKey') || []
      return resourceKeys.indexOf(targetKey) !== -1
    }
    this.$oneitfarm.getApiBaseUrl = () => {
      // return 'http://w5c0890d624f71.dev.oneitfarm.com/main.php/json/proxy/proxy?service=qae4c6zwfsdlor35ngwehnzvctmdhv9p&api='
      return window.BACKURL + '/proxy/proxy/?service=qae4c6zwfsdlor35ngwehnzvctmdhv9p&api='
    }
    // this.$oneitfarm.request = {
    //   post: aclAxios.post
    // }
  }
}).$mount('#app')
